import type { AddonsInsightsReportDto } from './AddonsInsightsReportDto';
import type { AddonsInsightsReport } from 'model/AddonsInsightsReport';

const n = (v: any) => (Number.isFinite(Number(v)) ? Number(v) : 0);

export const convertToAddonsInsightsReport = (dto: AddonsInsightsReportDto): AddonsInsightsReport => ({
    range: {
        start: dto?.range?.start ?? '',
        end: dto?.range?.end ?? ''
    },
    totals: {
        quantity: n(dto?.totals?.quantity),
        grossSales: n(dto?.totals?.gross_sales),
        discounts: n(dto?.totals?.discounts),
        refunds: n(dto?.totals?.refunds),
        netSales: n(dto?.totals?.net_sales),
        allNetSales: n(dto?.totals?.all_net_sales)
    },
    meta: {
        page: n(dto?.meta?.page) || 1,
        perPage: n(dto?.meta?.per_page) || 10,
        totalCount: n(dto?.meta?.total_count),
        totalPages: n(dto?.meta?.total_pages) || 1
    },
    addons: (dto?.addons ?? []).map(a => ({
        addonServiceId: String(a?.addon_service_id ?? ''),
        addonName: a?.addon_name ?? '—',
        category: a?.category ?? 'Add-On',
        quantity: n(a?.quantity),
        avgPrice: n(a?.avg_price),
        grossSales: n(a?.gross_sales),
        discounts: n(a?.discounts),
        refunds: n(a?.refunds),
        netSales: n(a?.net_sales),
        netAddonsSalesPct: n(a?.net_addons_sales_pct),
        allNetSalesPct: n(a?.all_net_sales_pct)
    }))
});
